export const data = [
  {
    id: 1,
    question: 'Q1. What is ReactJS?',
    answers: [
      {
        text: 'Server side Framework',
        correct: false,
      },
      {
        text: 'User-interface framework',
        correct: true,
      },
      {
        text: 'Library for building interaction interfaces',
        correct: false,
      },
      {
        text: 'non of above',
        correct: false,
      },
    ],
  },
  {
    id: 2,
    question: 'Q2. React is mainly used for building ___.',
    answers: [
      {
        text: 'Database',
        correct: false,
      },
      {
        text: 'Connectivity',
        correct: false,
      },
      {
        text: 'User interface',
        correct: true,
      },
      {
        text: 'Design Platform',
        correct: false,
      },
    ],
  },
  {
    id: 3,
    question: 'Q3. What are the two ways that data gets handled in React? ',
    answers: [
      {
        text: 'services & components',
        correct: false,
      },
      {
        text: 'props & state',
        correct: true,
      },
      {
        text: 'render & return',
        correct: false,
      },
      {
        text: 'none of above',
        correct: false,
      },
    ],
  },
  {
    id: 4,
    question: 'Q4. The lifecycle methods are mainly used for ___.',
    answers: [
      {
        text: 'keeping track of event history',
        correct: true,
      },
      {
        text: 'enhancing components',
        correct: false,
      },
      {
        text: 'freeing up resources',
        correct: false,
      },
      {
        text: 'none of above',
        correct: false,
      },
    ],
  },
  {
    id: 5,
    question:
      'Q5. Which is the right way of accessing a function fetch() from an h1 element in JSX?',
    answers: [
      {
        text: '<h1>{fetch()}</h1>',
        correct: false,
      },
      {
        text: '<h1>{(fetch)}</h1>',
        correct: false,
      },
      {
        text: '<h1>{fetch}</h1>',
        correct: true,
      },
      {
        text: '<h1>{({fetch})}</h1>',
        correct: false,
      },
    ],
  },
  {
    id: 6,
    question: 'Q6. What is used to pass data to a component from outside? ',
    answers: [
      {
        text: 'setState',
        correct: false,
      },
      {
        text: 'render with arguments',
        correct: false,
      },
      {
        text: 'PropTypes',
        correct: false,
      },
      {
        text: 'props',
        correct: true,
      },
    ],
  },
  {
    id: 7,
    question:
      'Q7. Which of the following methods in a React Component is called after the component is rendered for the first time?',
    answers: [
      {
        text: 'componentDidUpdate',
        correct: false,
      },
      {
        text: 'componentsDidMount',
        correct: true,
      },
      {
        text: 'componentMount',
        correct: false,
      },
      {
        text: 'componentUpdate',
        correct: false,
      },
    ],
  },
  {
    id: 8,
    question:
      'Q8. Which of the following is the correct syntax for a button click event handler foo? ',
    answers: [
      {
        text: '<button onclick={this.foo()}>',
        correct: false,
      },
      {
        text: '<button onclick={this.foo}>',
        correct: false,
      },
      {
        text: '<button onClick={this.foo()}>',
        correct: false,
      },
      {
        text: '<button onClick={this.foo}>',
        correct: true,
      },
    ],
  },
  {
    id: 9,
    question:
      'Q9. What will happen if you call setState() inside render() method? ',
    answers: [
      {
        text: 'Repetitive output appears on the screen',
        correct: true,
      },
      {
        text: 'Duplicate key error',
        correct: false,
      },
      {
        text: 'Stack overflow error',
        correct: false,
      },
      {
        text: 'Nothing happens',
        correct: false,
      },
    ],
  },
  {
    id: 10,
    question: 'Q10. A state in React.js is also known is ...... ',
    answers: [
      {
        text: 'A permanent storage',
        correct: false,
      },
      {
        text: 'An Internal storage of the component',
        correct: true,
      },
      {
        text: 'An External storage of the component',
        correct: false,
      },
      {
        text: 'All the above options',
        correct: false,
      },
    ],
  },
  {
    id: 11,
    question: ' Q11. The arbitrary inputs of components are called ___.',
    answers: [
      {
        text: 'Keys',
        correct: false,
      },
      {
        text: 'Props',
        correct: true,
      },
      {
        text: 'Elements',
        correct: false,
      },
      {
        text: 'Ref',
        correct: false,
      },
    ],
  },
  {
    id: 12,
    question: 'Q12. React was originally created by ..... ',
    answers: [
      {
        text: 'Jordan Walke',
        correct: true,
      },
      {
        text: 'Rasmus Lerdort',
        correct: false,
      },
      {
        text: 'James Gosling',
        correct: false,
      },
      {
        text: 'Dennis Ritchie',
        correct: false,
      },
    ],
  },
  {
    id: 13,
    question: 'Q13. .....helps react for keeping their data unidirectional',
    answers: [
      {
        text: 'JSX',
        correct: false,
      },
      {
        text: 'Flux',
        correct: true,
      },
      {
        text: 'DOM',
        correct: false,
      },
      {
        text: 'Props',
        correct: false,
      },
    ],
  },
  {
    id: 14,
    question:
      'Q14. .....port is default where the webpack-dev-server will run.',
    answers: [
      {
        text: '3030',
        correct: false,
      },
      {
        text: '8080',
        correct: true,
      },
      {
        text: '3306',
        correct: false,
      },
      {
        text: '3000',
        correct: false,
      },
    ],
  },
  {
    id: 15,
    question: 'Q15. What is Babel?',
    answers: [
      {
        text: 'A JavaScript transpiler',
        correct: false,
      },
      {
        text: 'A JavaScript interpreter',
        correct: true,
      },
      {
        text: 'A JavaScript compiler',
        correct: true,
      },
      {
        text: 'None of the above',
        correct: false,
      },
    ],
  },
  {
    id: 16,
    question: ' Congrats! Every day, I want to be a winner. I want to train my best, I want to work my best.  K.L. Rahul',
    answers: [],
  },
];
